import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const PageSound = ({ soundMap }) => {
  const { soundPath } = useSelector((state) => state.sounds);
  const isSoundOn = useSelector((state) => state.user.flags.sound);

  useEffect(() => {
    if (isSoundOn && soundPath && soundMap[soundPath]) {
      const audio = soundMap[soundPath];
      audio.muted = !isSoundOn;
      audio.volume = 0.1;
      audio.currentTime = 0;
      audio.play().catch(error => {
        console.error('Error of playing sound:', error);
      });
    }
  }, [soundPath, isSoundOn, soundMap]);

  return null;
};

export default PageSound;
